// extracted by mini-css-extract-plugin
export default {"layout":"_Wf5QlkpGY_pdp"};